/* Availability check for the Formula Calculator (see js/ui-pdp.js).
   Also owns adding a plan to the cart (stock re-check + rollback). Loaded before
   ui-pdp.js and exposed as window.FormulaCalculatorStock. */

(function () {
  // Variant id -> product handle for every single-unit variant the calculator
  // can add to the cart (generated by build-theme-assets.py from
  // data/variant_handles.json). A plan can span several stages and each stage
  // is its own Shopify product, so stock is looked up per product.
  const STAGE_HANDLES = {"45125550538916": "hipp-dutch-stage-1-formula", "45132886376612": "hipp-dutch-hypoallergenic-stage-1-formula", "45132901187748": "hipp-dutch-hypoallergenic-stage-2-formula", "45132917801124": "hipp-dutch-stage-2-formula", "45132920094884": "hipp-dutch-stage-3-formula", "45132935921828": "hipp-german-hypoallergenic-stage-1-formula", "45132942606500": "hipp-german-hypoallergenic-stage-2-formula", "45132943556772": "hipp-german-hypoallergenic-stage-pre-formula", "45133987414180": "hipp-german-hypoallergenic-ready-to-feed-stage-pre-formula", "45133987676324": "hipp-german-ready-to-feed-stage-1-formula", "45133988429988": "hipp-german-ready-to-feed-stage-2-formula", "45133990756516": "hipp-german-ready-to-feed-pre-stage-pre-formula", "45133991215268": "hipp-uk-ready-to-feed-stage-1-formula", "45134003142820": "hipp-german-ready-to-feed-pre-stage-pre-formula-90-ml", "45134006517924": "hipp-uk-ready-to-feed-stage-2-formula", "45134007173284": "hipp-uk-ready-to-feed-stage-3-formula", "45134025883812": "hipp-german-pre-stage-pre-formula", "45134026506404": "hipp-german-stage-1-formula", "45134027456676": "hipp-german-stage-2-formula", "45134028046500": "hipp-german-stage-3-formula", "45134129561764": "hipp-goat-stage-1-formula", "45134148665508": "hipp-goat-stage-2-formula", "45134274068644": "hipp-uk-stage-1-formula", "45134301233316": "hipp-uk-stage-2-formula", "45134333706404": "hipp-uk-stage-3-formula", "45134436565156": "holle-goat-stage-1-formula", "45134464581796": "holle-goat-stage-2-formula", "45134471463076": "holle-goat-stage-3-formula", "45134573011108": "holle-goat-stage-4-formula", "45134578581668": "holle-goat-stage-pre-formula", "45134589001892": "holle-stage-1-formula-1", "45134593130660": "holle-stage-pre-formula", "45134629798052": "holle-stage-2-formula", "45134634287268": "holle-stage-3-formula", "45134641201316": "holle-stage-4-formula", "45134749302948": "kendamil-stage-1-formula", "45134760050852": "kendamil-stage-2-formula", "45135840608420": "nannycare-stage-1-formula", "45135844606116": "nannycare-stage-2-formula", "45135849914532": "nannycare-stage-3-formula", "45143819583652": "kendamil-stage-3-formula", "45187066134692": "hipp-anti-reflux", "45187067543716": "hipp-comfort-formula", "45187072884900": "hipp-german-1-formula", "45187080159396": "hipp-german-no-starch-stage-2", "45211434090660": "hipp-uk-ready-to-feed-stage-1-formula-with-teats-6-pack-90ml", "45211439759524": "kendamil-ready-to-feed-stage-1-formula", "45259738120356": "hipp-dutch-stage-4-formula", "46150223134884": "kendamil-ready-to-feed-stage-2-formula", "51685289034091": "kendamil-goat-stage-1-formula", "51685329371499": "kendamil-goat-stage-2-formula", "51685343297899": "kendamil-goat-stage-3-formula", "51685348409707": "kendamil-comfort-formula", "51698652709227": "kendamil-premium-cow-stage-1-formula", "51698703368555": "kendamil-premium-cow-stage-2-formula", "51698722996587": "kendamil-premium-cow-stage-3-formula", "51698731778411": "holle-dutch-goat-stage-1-formula", "51698737643883": "holle-dutch-goat-stage-2-formula", "51698738790763": "holle-dutch-goat-stage-3-formula", "51719632978283": "hipp-german-hypoallergenic-ready-to-feed-stage-pre-formula-90-ml", "51746683158891": "hipp-german-goat-stage-pre-formula", "51747550069099": "hipp-german-goat-stage-2-formula", "51997008593259": "hipp-uk-comfort-formula", "51997122625899": "hipp-uk-anti-reflux-formula", "52969478750571": "holle-ready-to-feed-stage-pre-1-formula", "53358711472491": "kendamil-uk-organic-cow-stage-1-formula", "53358724383083": "holle-dutch-stage-1-formula", "53361004216683": "kendamil-uk-organic-cow-stage-2-formula", "53361274716523": "kendamil-uk-organic-cow-stage-3-formula", "53361762074987": "holle-dutch-stage-2-formula", "53361768300907": "holle-dutch-stage-3-formula", "53361799135595": "holle-dutch-stage-4-formula", "53363727073643": "hipp-pure-german-stage-pre-formula", "53363740836203": "holle-dutch-goat-stage-4-formula", "53363954745707": "hipp-pure-german-stage-1-formula", "53363988922731": "hipp-pure-german-stage-2-formula", "53364564132203": "hipp-pure-german-stage-3-formula", "53364678099307": "hipp-pure-german-stage-4-formula", "53794783232363": "kendamil-organic-ready-to-feed-stage-1-formula", "53795068510571": "kendamil-organic-ready-to-feed-stage-2-formula", "53795555508587": "kendamil-organic-ready-to-feed-stage-3-formula"};
  const stockCache = {};

  // Live stock for one product via templates/product.stock.liquid - Shopify's
  // public product feeds only say "available" yes/no, not how many are left.
  async function fetchStock(handle, fresh) {
    const hit = stockCache[handle];
    if (!fresh && hit && Date.now() - hit.at < 20000) return hit.data;
    const res = await fetch(`/products/${handle}?view=stock&_=${Date.now()}`);
    if (!res.ok) throw new Error(`stock lookup ${res.status}`);
    const data = await res.json();
    stockCache[handle] = { at: Date.now(), data };
    return data;
  }

  // Lines of this plan that Shopify could not fulfil right now, counting what
  // is already in the cart. An empty list means all good. A failed lookup
  // never blocks the customer: Shopify itself still refuses what isn't there.
  async function findStockProblems(lineItems, fresh, labels) {
    try {
      const cart = await (await fetch("/cart.js", { cache: "no-store" })).json();
      const inCart = {};
      cart.items.forEach((i) => {
        inCart[i.variant_id] = (inCart[i.variant_id] || 0) + i.quantity;
      });
      const handles = [...new Set(lineItems.map((l) => STAGE_HANDLES[l.id]).filter(Boolean))];
      const products = {};
      await Promise.all(
        handles.map(async (h) => {
          products[h] = await fetchStock(h, fresh);
        })
      );
      const problems = [];
      for (const line of lineItems) {
        const product = products[STAGE_HANDLES[line.id]];
        const variant = product && product.variants.find((v) => v.id === line.id);
        if (!variant) continue;
        if (!variant.managed || variant.policy === "continue") continue;
        const have = Math.max(variant.qty, 0);
        const already = inCart[line.id] || 0;
        const free = Math.max(have - already, 0);
        if (line.quantity > free) problems.push({ label: labels && labels[line.id], free, need: line.quantity, already, have });
      }
      return problems;
    } catch (e) {
      console.warn("Formula calculator stock check skipped:", e);
      return [];
    }
  }

  // Kept short on purpose: the card already shows which stage is which. The
  // label (e.g. "Stage 2") is only set for plans that span several stages.
  function stockMessage(problems) {
    return problems
      .map((p) => {
        let text;
        if (p.have === 0) text = "out of stock";
        else if (p.free === 0) text = "all available units are already in your cart";
        else text = `only ${p.free} in stock, you need ${p.need}`;
        if (!p.label) text = text.charAt(0).toUpperCase() + text.slice(1);
        return `${p.label ? p.label + ": " : ""}${text}.`;
      })
      .join(" ");
  }

  function showStockProblem(btn, problems) {
    const card = btn.closest(".fc-card");
    const warning = card && card.querySelector(".fc-stock-warning");
    if (warning) {
      warning.textContent = stockMessage(problems);
      warning.hidden = false;
    }
    btn.disabled = true;
    btn.textContent = "Not available right now";
  }

  // A failed /cart/add.js can still have added part of the plan (Shopify adds
  // what is available and then reports the shortfall), so put every line of
  // this plan back to what the cart held before.
  async function restoreCart(lineItems, before) {
    const updates = {};
    lineItems.forEach((l) => {
      updates[l.id] = before[l.id] || 0;
    });
    await fetch("/cart/update.js", {
      method: "POST",
      headers: { "Content-Type": "application/json", Accept: "application/json" },
      body: JSON.stringify({ updates }),
    });
  }

  async function addPlanToCart(lineItems, btn, labels) {
    const originalText = btn.dataset.fcLabel || btn.textContent;
    btn.dataset.fcLabel = originalText;
    btn.disabled = true;
    btn.textContent = "Checking availability...";

    const problems = await findStockProblems(lineItems, true, labels);
    if (problems.length) {
      showStockProblem(btn, problems);
      return;
    }

    btn.textContent = "Adding...";
    const before = {};
    try {
      const cart = await (await fetch("/cart.js", { cache: "no-store" })).json();
      cart.items.forEach((i) => {
        before[i.variant_id] = (before[i.variant_id] || 0) + i.quantity;
      });
    } catch (e) {
      /* the stock check above already ran; rollback just becomes best effort */
    }
    try {
      const res = await fetch("/cart/add.js", {
        method: "POST",
        headers: { "Content-Type": "application/json", Accept: "application/json" },
        body: JSON.stringify({ items: lineItems }),
      });
      if (!res.ok) {
        const err = await res.json().catch(() => ({}));
        throw new Error(err.description || `Cart add failed (${res.status})`);
      }
      window.location.href = "/cart";
    } catch (e) {
      await restoreCart(lineItems, before).catch(() => {});
      btn.disabled = false;
      btn.textContent = originalText;
      alert(`Sorry, we couldn't add this plan to your cart (${e.message}). Nothing was added, please try again.`);
      console.error("Formula calculator add-to-cart failed:", e);
    }
  }

  window.FormulaCalculatorStock = { findStockProblems, showStockProblem, addPlanToCart, stageHandles: STAGE_HANDLES };
})();
